module.exports = __webpack_public_path__ + "img/Schriftzug_TSG-Bochum800x78.f553243b.png";